import {ITimestamped} from "./Database.js";
import {IFeature} from "./Feature.ts";
import {IAction} from "./Action.ts";
import {IUserInputRequest} from "./UserInputRequest.ts";


export enum JOB_STATUS {
    UNASSIGNED = "UNASSIGNED",
    DELETED = "DELETED",

    ANALYSIS_PENDING = "ANALYSIS_PENDING",
    ANALYSIS_STARTED = "ANALYSIS_STARTED",
    ANALYSIS_FAILED = "ANALYSIS_FAILED",
    ANALYSIS_COMPLETE = "ANALYSIS_COMPLETE",

    EXECUTION_PENDING = "EXECUTION_PENDING",
    EXECUTION_STARTED = "EXECUTION_STARTED",
    EXECUTION_CALIBRATING = "EXECUTION_CALIBRATING",
    EXECUTION_FABRICATING = "EXECUTION_FABRICATING",
    EXECUTION_WAITING_FOR_INPUT = "EXECUTION_WAITING_FOR_INPUT",
    EXECUTION_ABORTING = "EXECUTION_ABORTING",
    EXECUTION_FAILED = "EXECUTION_FAILED",
    EXECUTION_SUCCESS = "EXECUTION_SUCCESS",
}


export enum JOB_STATUS_LABEL {
    UNASSIGNED = "Unassigned",
    DELETED = "Deleted",

    ANALYSIS_PENDING = "Analysis Pending",
    ANALYSIS_STARTED = "Analyzing",
    ANALYSIS_FAILED = "Analysis Failed",
    ANALYSIS_COMPLETE = "Ready",

    EXECUTION_PENDING = "Execution Pending",
    EXECUTION_STARTED = "Executing",
    EXECUTION_CALIBRATING = "Calibrating",
    EXECUTION_FABRICATING = "Fabricating",
    EXECUTION_WAITING_FOR_INPUT = "Waiting for Input",
    EXECUTION_ABORTING = "Aborting",
    EXECUTION_FAILED = "Failed",
    EXECUTION_SUCCESS = "Success",
}

export const JOB_STATUS_CATEGORY = {
    CREATED: [JOB_STATUS.UNASSIGNED, JOB_STATUS.ANALYSIS_PENDING, JOB_STATUS.ANALYSIS_STARTED, JOB_STATUS.ANALYSIS_FAILED, JOB_STATUS.ANALYSIS_COMPLETE],
    RUNNING: [JOB_STATUS.EXECUTION_PENDING, JOB_STATUS.EXECUTION_STARTED, JOB_STATUS.EXECUTION_CALIBRATING, JOB_STATUS.EXECUTION_FABRICATING, JOB_STATUS.EXECUTION_WAITING_FOR_INPUT],
    FINISHED: [JOB_STATUS.EXECUTION_FAILED, JOB_STATUS.EXECUTION_SUCCESS],
    FAILED: [JOB_STATUS.ANALYSIS_FAILED, JOB_STATUS.EXECUTION_FAILED],
    EXECUTING: [JOB_STATUS.EXECUTION_STARTED, JOB_STATUS.EXECUTION_CALIBRATING, JOB_STATUS.EXECUTION_FABRICATING, JOB_STATUS.EXECUTION_WAITING_FOR_INPUT, JOB_STATUS.EXECUTION_ABORTING],
    DELETED: [JOB_STATUS.DELETED],
};

export enum MODEL_ORIGIN {
    UNKNOWN = "UNKNOWN",
    KYUB = "KYUB",
    SCRIPT = "SCRIPT",
}

export interface IJobSpec {
    cutplan: string;
    title?: string;
    modelId?: {
        modelId: string;
        origin: MODEL_ORIGIN;
    };
    // user?: IUser;
    imageId?: string;
    cutterId?: string;
    calibrationIds?: string[];
    sheets?: string[] | ISheet[];
    sheetPrototype: ISheetPrototype;
    features?: IFeature[];
}


export interface IJob extends IJobSpec, ITimestamped {
    _id: string;
    modelId: {
        modelId: string;
        origin: MODEL_ORIGIN;
    }
    status: JOB_STATUS;
    statusReason?: string;
    actionOrder?: IAction[];
    lastActiveActionId?: string | null;
    currentInputRequest?: IUserInputRequest | null;
    activeCalibrationId?: string | null;
}

// ToDo: Move somewhere else
export interface IReadonlyVector2 {
    readonly x: number;
    readonly y: number;
}

// ToDo: Move somewhere else
export interface IReadonlyPolygon2D {
    readonly points: IReadonlyVector2[];
}

export interface ISheet {
    material: string;
    thickness: number;
    outline: IReadonlyPolygon2D;
}

export interface ISheetPrototype {
    outline: IReadonlyPolygon2D;
}